import {
  Box,
  Divider,
  Flex,
  Grid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useBreakpointValue,
  useSteps
} from "@chakra-ui/react";
import HeadingSS from "App/BsesPoc/components/common/Heading/HeadingSS";
import ProgressStepper from "App/BsesPoc/components/common/ProgressStepper/ProgressStepper";
import ShadowBox from "components/common/ShadowBox/ShadowBox";
import { useContext, useState } from "react";
import WorkFlowFormForeign from "./WorkFlowFormForeign";
import { AppContext } from "AppProvider/AppContext";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  showError: boolean;
  loading: boolean;
  setShowError: any;
  submitForm: any;
  initialValues: any;
  type?: string;
  setDeletedApproavals?: any;
};

const steps = [
  { title: "Workflow Features" },
  { title: "Users Section" },
];

export default function WorkFlowFormModalForeign({
  type,
  isOpen,
  onClose,
  showError,
  loading,
  setShowError,
  submitForm,
  initialValues,
  setDeletedApproavals,
}: ModalProps): JSX.Element {
  const { workflowProcess } = useContext(AppContext)
  const isMobileView = useBreakpointValue({ base: true, lg: false });
  const [disabledSteps, setDisabledSteps] = useState([0]);
  let width = "97vw";
  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length
  });

  const handleCloseModal = () => {
    setActiveStep(0);
    setDisabledSteps([0]);
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={handleCloseModal} size="full" isCentered>
        <ModalOverlay />
        <ModalContent
          position="fixed"
          right={isOpen ? "0" : `-${width}`}
          top="0"
          height="100vh"
          width={!isMobileView ? width : "100vw"}
          animation={`${isOpen ? "slideIn" : "slideOut"
            } 0.8s ease-in-out forwards`}
        >
          <ModalHeader
            fontSize={{ base: "1rem", md: "1.6rem" }}
            color="teal.300"
            fontWeight="700"
            p=".6rem .6rem"
            ml="1rem"
            textTransform="capitalize"
          >
            {type} Foreign WorkFlow
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody p={0}>
            <Grid
              h="80vH"
              templateColumns={{ base: "1fr", lg: "5fr 1fr" }}
              px={{ base: 2, md: 4 }}
              py={0}
              gap={4}
            >
              {isMobileView && (
                <Flex justifySelf="center">
                  <ProgressStepper
                    activeStep={activeStep}
                    steps={steps}
                    orientation={"horizontal"}
                    setActiveStep={setActiveStep}
                    disabledSteps={disabledSteps}
                  />
                </Flex>
              )}
              <ShadowBox>
                <HeadingSS
                  fontSize="lg"
                  headingSS={steps[activeStep].title}
                  ml={2}
                  mb={2}
                />
                <Divider />
                <Box
                  overflow="hidden auto"
                  className="customScrollBar"
                  h={{ base: "70vh", lg: "78vH" }}
                  w="100%"
                  maxW={{ base: "90vw", lg: "78vW" }}
                  position="relative"
                >
                  <WorkFlowFormForeign
                    setDeletedApproavals={setDeletedApproavals}
                    type={type}
                    initialVal={initialValues}
                    loading={loading}
                    submitForm={submitForm}
                    showError={showError}
                    setShowError={setShowError}
                    onClose={handleCloseModal}
                    activePage={activeStep}
                    setActiveSteps={setActiveStep}
                    setDisabledSteps={setDisabledSteps}
                    disabledSteps={disabledSteps}
                    steps={steps}
                    workflowProcess={workflowProcess}
                  />
                </Box>
              </ShadowBox>
              {!isMobileView && (
                <Box h="fit-content">
                  <ProgressStepper
                    activeStep={activeStep}
                    steps={steps}
                    orientation={"vertical"}
                    setActiveStep={setActiveStep}
                    disabledSteps={disabledSteps}
                  />
                </Box>
              )}
            </Grid>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
        <style>
          {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
        </style>
      </Modal>
    </>
  );
}
